Vue.component('house-sort', {
    props: {
        data: {
            type: Array,
            default: [],
        }
    },
    data: function () {
        return {
            price: null,
            name: null,
        }
    },
    created: function(){
    },
    methods: {
        byPriceAsc: function(){
            var houses = this.data.slice();
            return houses.sort(function (house1, house2) {
                return house1.dailyPrice - house2.dailyPrice;
            });
        },
        byPriceDesc: function(){
            return this.byPriceAsc().reverse();
        },
        byNameAsc: function(){
            var houses = this.data.slice();
            return houses.sort(function (house1, house2) {
                if (house1.houseName.toLowerCase() > house2.houseName.toLowerCase()){
                    return 1;
                }
                else if (house1.houseName.toLowerCase() < house2.houseName.toLowerCase()){
                    return -1;
                }
                return 0;
            });
        },
        byNameDesc: function(){
            return this.byNameAsc().reverse();
        },
        sortByPrice: function(direction){
            if (direction){
                var houses = direction == 'asc' ? this.byPriceAsc() : this.byPriceDesc();
                this.$emit('input', houses);
            }
            this.name = null;
        },
        sortByName: function(direction){
            if (direction){
                var houses = direction == 'asc' ? this.byNameAsc() : this.byNameDesc();
                this.$emit('input', houses);
            }
            this.price = null;
        },
        reset: function(){
            this.price = null;
            this.name = null;
        }
    },
    watch: {
        data: {
            handler: function () {
                this.$emit('input', this.data);
            },
            deep: true
        }
    }
});